import * as React from 'react';
import cn from 'classnames';

import { IconSize, CommonIconProps } from 'shared/entities/components/Icon';

import BaseIcon from '../BaseIcon';

import './ArrowFilledIcon.modules.scss';

type Props = CommonIconProps & {
  direction?: 'left' | 'right' | 'top' | 'bottom';
};

const ArrowFilledIcon: React.FC<Props> = ({
  direction = 'bottom',
  ...rest
}: Props) => {
  return (
    <BaseIcon
      iconSize={IconSize.XM}
      svgProps={{
        viewBox: '0 0 20 20'
      }}
      {...rest}
      styleName={cn('arrow-icon', `arrow-icon_${direction}`)}
    >
      <path
        d="M15.3537 8.35375L10.3537 13.3538C10.3072 13.4002 10.2521 13.4371 10.1914 13.4623C10.1307 13.4874 10.0656 13.5004 9.99991 13.5004C9.9342 13.5004 9.86913 13.4874 9.80844 13.4623C9.74774 13.4371 9.69259 13.4002 9.64616 13.3538L4.64616 8.35375C4.57615 8.28382 4.52847 8.1947 4.50914 8.09765C4.48982 8.00061 4.49972 7.90002 4.53759 7.8086C4.57547 7.71719 4.63962 7.63908 4.72191 7.58414C4.80421 7.5292 4.90096 7.49992 4.99991 7.5H14.9999C15.0989 7.49992 15.1956 7.5292 15.2779 7.58414C15.3602 7.63908 15.4243 7.71719 15.4622 7.8086C15.5001 7.90002 15.51 8.00061 15.4907 8.09765C15.4713 8.1947 15.4237 8.28382 15.3537 8.35375Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default ArrowFilledIcon;
